<div class="h-screen flex flex-col overflow-hidden bg-pageBg">
    <app-header class="shrink-0"></app-header>
    <div class="flex-1 flex flex-col min-h-0 overflow-hidden pt-4 pb-[44px] text-gray-800 antialiased">
        <div class="w-full mx-auto px-4 xl:px-8 flex flex-col flex-1 h-full overflow-hidden">

            <!-- ================================================================ -->
            <!-- PAGE HEADER -->
            <!-- ================================================================ -->
            <div class="relative px-6 py-5 mb-6 bg-white border border-gray-200 shadow-sm rounded-xl overflow-hidden flex flex-col sm:flex-row items-center justify-between"
                style="background-color: aliceblue;">
                <div
                    class="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brandPurple via-brandPurpleDark to-brandAccent">
                </div>
                <div>
                    <h1 class="text-xl f-700 text-brandPurple tracking-tight">User Groups</h1>
                    <p class="text-gray-500 mt-1">Manage groups and assign users or channels.</p>
                    <!-- <p *ngIf="isLoaded" class="text-xs text-gray-400 mt-0.5">{{ rowsInfo }}</p> -->
                </div>

                <div class="flex items-center gap-4 mt-4 sm:mt-0">
                    <div *ngIf="groupList.length > 0">
                        <input type="text"
                            class="form-input text-sm p-2 border border-gray-300 rounded-md focus:ring-brandAccent focus:border-brandAccent"
                            placeholder="Quick Search..." [(ngModel)]="search"
                            (ngModelChange)="currentPage = 1; updateTableInformation(1)" [disabled]="isRefreshTable">
                    </div>
                    <button *ngIf="groupList.length > 0"
                        class="bg-gray-100 hover:bg-gray-200 text-gray-700 px-3 py-1.5 rounded-md text-sm font-semibold transition"
                        (click)="showHideColumnSettings()" [disabled]="isRefreshTable">
                        Columns
                    </button>
                    <button *ngIf="groupList.length > 0"
                        class="bg-gray-100 hover:bg-gray-200 text-gray-700 px-3 py-1.5 rounded-md text-sm font-semibold transition"
                        (click)="getGroupList(true, false)" [disabled]="isRefreshTable">
                        <span *ngIf="!isRefreshTable">Refresh</span>
                        <span *ngIf="isRefreshTable">Loading...</span>
                    </button>
                    <button
                        class="bg-brandAccent hover:bg-brandPurple text-white px-4 py-1.5 rounded-md text-sm font-bold shadow-sm transition"
                        (click)="openForm()">
                        Create Group
                    </button>
                </div>
            </div>

            <!-- ================================================================ -->
            <!-- MESSAGES & REFRESH BAR -->
            <!-- ================================================================ -->
            <div *ngIf="message" class="mb-4 bg-red-50 border-l-4 border-red-500 p-4 rounded-md shadow-sm">
                <p class="text-red-700 text-sm font-bold">{{ message }}</p>
            </div>
            <div *ngIf="isRefreshTable"
                class="mb-4 bg-blue-50 border-l-4 border-blue-400 p-3 rounded-md shadow-sm flex justify-between items-center">
                <span class="text-blue-700 text-sm font-medium">{{ refreshTableText }}</span>
                <span class="text-blue-600 text-sm font-bold">{{ totalRecords }} records</span>
            </div>

            <!-- ================================================================ -->
            <!-- LOADING STATE -->
            <!-- ================================================================ -->
            <div *ngIf="!isLoaded && !groupList.length" class="flex justify-center items-center py-16">
                <span class="text-gray-400 text-sm">Loading groups...</span>
            </div>

            <!-- ================================================================ -->
            <!-- GROUPS TABLE -->
            <!-- ================================================================ -->
            <div class="bg-white border border-gray-200 rounded-xl shadow-sm flex flex-col flex-1 overflow-hidden min-h-0 mb-4"
                *ngIf="isLoaded && groupList.length > 0">
                <div class="overflow-auto flex-1 relative custom-scrollbar">
                    <table class="min-w-full text-sm text-left table-fixed">
                        <thead class="bg-gray-50 border-b border-gray-200 text-gray-700">
                            <tr>
                                <th *ngIf="columnVisibility['name']"
                                    class="sticky top-0 z-10 px-4 py-3 f-700 uppercase cursor-pointer hover:bg-gray-100 shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="background-color: aliceblue;" (click)="setSort('name')">
                                    Name
                                    <span *ngIf="sortType === 'name' && !sortReverse" class="ml-1"><i
                                            class="fa-solid fa-caret-down"></i></span>
                                    <span *ngIf="sortType === 'name' && sortReverse" class="ml-1"><i
                                            class="fa-solid fa-caret-up"></i></span>
                                </th>
                                <th *ngIf="columnVisibility['addChannel']"
                                    class="sticky top-0 z-10 px-4 py-3 f-700 uppercase text-center shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="width: 12%; background-color: aliceblue;">
                                    Channels
                                </th>
                                <th *ngIf="columnVisibility['addUsers']"
                                    class="sticky top-0 z-10 px-4 py-3 f-700 uppercase text-center shadow-[inset_0_-1px_0_rgba(0,0,0,0.1)]"
                                    style="width: 12%; background-color: aliceblue;">
                                    Users
                                </th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-100">

                            <tr *ngIf="getPaginatedGroups().length === 0">
                                <td colspan="3" class="px-4 py-8 text-center text-gray-500">
                                    No groups found.
                                </td>
                            </tr>

                            <tr *ngFor="let group of getPaginatedGroups(); let i = index"
                                class="hover:bg-pageBg transition-colors cursor-pointer"
                                [ngClass]="{'bg-brandAccent/5': i === selectedRow}" (click)="setClickedRow(i)"
                                (dblclick)="dblClickAction(group)">
                                <td *ngIf="columnVisibility['name']" class="px-4 py-3 f-500 text-gray-800">
                                    {{ group.name }}
                                </td>
                                <td *ngIf="columnVisibility['addChannel']" class="px-4 py-3 text-center">
                                    <button class="text-brandAccent hover:text-brandPurple font-bold"
                                        (click)="openChannelForm(); $event.stopPropagation()">
                                        Add Channel
                                    </button>
                                </td>
                                <td *ngIf="columnVisibility['addUsers']" class="px-4 py-3 text-center">
                                    <button class="text-brandAccent hover:text-brandPurple font-bold"
                                        (click)="openUsersForm(group.id); $event.stopPropagation()">
                                        Add Users
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Pagination -->
                <div
                    class="flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6 shrink-0 bg-gray-50/50">
                    <div class="text-sm text-gray-700">
                        Showing <span class="font-medium">{{ (currentPage - 1) * pageSize + 1 }}</span> to
                        <span class="font-medium">{{ getVisibleCount() }}</span> of
                        <span class="font-medium">{{ getTotalFilteredCount() }}</span> records
                    </div>
                    <div class="flex gap-2 items-center">
                        <button class="px-3 py-1 border border-gray-300 rounded text-sm hover:bg-gray-50"
                            [disabled]="currentPage === 1" (click)="pageChange(currentPage - 1)">Prev</button>
                        <button class="px-3 py-1 border border-gray-300 rounded text-sm hover:bg-gray-50"
                            [disabled]="currentPage * pageSize >= getTotalFilteredCount()"
                            (click)="pageChange(currentPage + 1)">Next</button>
                        <div class="flex gap-1 ml-4">
                            <button class="px-2 py-1 border rounded text-xs"
                                [ngClass]="pageSize === 10 ? 'bg-brandAccent text-white border-brandAccent' : 'border-gray-300 hover:bg-gray-50'"
                                (click)="pageSize = 10; currentPage = 1; updateTableInformation(1)">10</button>
                            <button class="px-2 py-1 border rounded text-xs"
                                [ngClass]="pageSize === 25 ? 'bg-brandAccent text-white border-brandAccent' : 'border-gray-300 hover:bg-gray-50'"
                                (click)="pageSize = 25; currentPage = 1; updateTableInformation(1)">25</button>
                            <button class="px-2 py-1 border rounded text-xs"
                                [ngClass]="pageSize === 50 ? 'bg-brandAccent text-white border-brandAccent' : 'border-gray-300 hover:bg-gray-50'"
                                (click)="pageSize = 50; currentPage = 1; updateTableInformation(1)">50</button>
                            <button class="px-2 py-1 border rounded text-xs"
                                [ngClass]="pageSize === 100 ? 'bg-brandAccent text-white border-brandAccent' : 'border-gray-300 hover:bg-gray-50'"
                                (click)="pageSize = 100; currentPage = 1; updateTableInformation(1)">100</button>
                        </div>
                    </div>
                </div>
            </div>



            <!-- Empty State -->
            <div *ngIf="isLoaded && groupList.length === 0"
                class="bg-white border border-gray-200 rounded-xl shadow-sm p-16 text-center">
                <p class="text-gray-400 text-sm">No groups found. Create your first group.</p>
                <button
                    class="mt-4 bg-brandAccent hover:bg-brandPurple text-white px-4 py-2 rounded-md text-sm font-bold shadow-sm transition"
                    (click)="openForm()">Create Group</button>
            </div>

        </div>
        <footer class="login-footer">
            <span *ngIf="copyrightDetails">
                &copy; {{ copyrightDetails.from_year }} - {{ copyrightDetails.to_year }},
                Retail Calculus or its affiliates. All rights reserved.
            </span>
            <span *ngIf="!copyrightDetails">
                &copy; 2016 - 2026, Retail Calculus or its affiliates. All rights reserved.
            </span>

            <div class="footer-links">
                <a href="javascript:void(0)">Privacy Policy</a>
                <a href="javascript:void(0)">Terms of Use</a>
                <span class="version" *ngIf="copyrightDetails?.app_version">
                    Version {{ copyrightDetails.app_version }}
                </span>
            </div>
        </footer>
    </div>
</div>

<!-- ================================================================ -->
<!-- CREATE / UPDATE GROUP MODAL -->
<!-- ================================================================ -->
<div *ngIf="isShowGroup"
    class="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
    <div class="bg-white w-full max-w-lg rounded-xl shadow-2xl flex flex-col overflow-hidden max-h-[90vh]">
        <!-- Header -->
        <div class="px-6 py-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center">
            <h2 class="text-xl font-bold text-gray-800">
                <span *ngIf="!isDeleteSuccess && !isConfirmDelete && isCreateGroup">Create <strong>Group</strong></span>
                <span *ngIf="!isDeleteSuccess && !isConfirmDelete && !isCreateGroup">Update
                    <strong>Group</strong></span>
                <span *ngIf="isDeleteSuccess || isConfirmDelete">Delete <strong>Group</strong></span>
            </h2>
            <button class="text-gray-400 hover:text-gray-600 focus:outline-none" (click)="closeForm()">
                <span class="text-2xl font-light">&times;</span>
            </button>
        </div>

        <!-- Form View -->
        <div *ngIf="!(isSaveSuccess || isUpdateSuccess || isConfirmDelete || isDeleteSuccess)"
            class="p-6 overflow-y-auto">
            <div class="flex flex-col gap-4">
                <div>
                    <label class="block text-sm font-semibold text-gray-700 mb-1">
                        Group Name
                        <span
                            [style.color]="group.name?.length >= 2 && group.name?.length <= 40 ? '#10b981' : '#ef4444'">*</span>
                    </label>
                    <input type="text" [(ngModel)]="group.name"
                        class="w-full px-4 py-3 bg-gray-50 border rounded-lg text-sm transition-all"
                        [class.border-red-500]="group.name?.length > 0 && (group.name?.length < 2 || group.name?.length > 40)"
                        [class.border-green-500]="group.name?.length >= 2 && group.name?.length <= 40"
                        [class.border-gray-200]="!group.name" placeholder="Enter Group Name" maxlength="45">
                    <p *ngIf="group.name?.length > 0 && (group.name?.length < 2 || group.name?.length > 40)"
                        class="text-red-500 text-xs mt-1">
                        Group name must be between 2 and 40 characters
                    </p>

                </div>
            </div>
            <div *ngIf="message" class="mt-4 bg-red-50 border-l-4 border-red-500 p-3 rounded-md">
                <p class="text-red-700 text-sm">{{ message }}</p>
            </div>
        </div>

        <!-- Save Success -->
        <div *ngIf="isSaveSuccess" class="p-6 text-center">
            <div class="text-green-500 text-5xl mb-4">✓</div>
            <p class="text-lg font-bold text-gray-800 mb-4">Group Created Successfully!</p>
            <div class="flex justify-center gap-3">
                <button
                    class="px-4 py-2 bg-brandAccent hover:bg-brandPurple text-white rounded-md shadow-sm text-sm font-bold transition"
                    (click)="createAnotherForm()">Create Another</button>
                <button
                    class="px-4 py-2 border border-gray-300 bg-white text-gray-700 rounded-md shadow-sm text-sm font-bold hover:bg-gray-50 transition"
                    (click)="closeForm()">Close</button>
            </div>
        </div>

        <!-- Update Success -->
        <div *ngIf="isUpdateSuccess" class="p-6 text-center">
            <div class="text-green-500 text-5xl mb-4">✓</div>
            <p class="text-lg font-bold text-gray-800 mb-4">Group Updated Successfully!</p>
            <div class="flex justify-center gap-3">
                <button
                    class="px-4 py-2 border border-gray-300 bg-white text-gray-700 rounded-md shadow-sm text-sm font-bold hover:bg-gray-50 transition"
                    (click)="closeForm()">Close</button>
            </div>
        </div>

        <!-- Delete Success -->
        <div *ngIf="isDeleteSuccess" class="p-6 text-center">
            <div class="text-green-500 text-5xl mb-4">✓</div>
            <p class="text-lg font-bold text-gray-800 mb-4">Group Deleted Successfully!</p>
            <div class="flex justify-center gap-3">
                <button
                    class="px-4 py-2 border border-gray-300 bg-white text-gray-700 rounded-md shadow-sm text-sm font-bold hover:bg-gray-50 transition"
                    (click)="closeForm()">Close</button>
            </div>
        </div>

        <!-- Confirm Delete -->
        <div *ngIf="isConfirmDelete && !isDeleteSuccess" class="p-6 text-center">
            <p class="text-brandAccent font-medium mb-2">Do you want to delete this Group?</p>
            <h3 class="text-xl font-bold text-gray-800 mb-6">{{ group?.name }}</h3>
            <div *ngIf="message" class="mb-4 bg-red-50 border-l-4 border-red-500 p-3 rounded-md">
                <p class="text-red-700 text-sm">{{ message }}</p>
            </div>
            <div class="flex justify-center gap-3">
                <button
                    class="px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-md shadow-sm text-sm font-bold transition"
                    (click)="removeGroup(group)">Yes, Delete!</button>
                <button
                    class="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-md shadow-sm text-sm font-bold transition"
                    (click)="isConfirmDelete = false">Cancel</button>
            </div>
        </div>

        <!-- Footer -->
        <div *ngIf="!(isSaveSuccess || isUpdateSuccess || isConfirmDelete || isDeleteSuccess)"
            class="px-6 py-4 border-t border-gray-200 bg-gray-50 flex justify-between gap-3 rounded-b-xl">
            <div>
                <button *ngIf="!isCreateGroup"
                    class="px-4 py-2 bg-red-50 hover:bg-red-100 text-red-600 border border-red-200 rounded-md shadow-sm text-sm font-bold transition"
                    (click)="showconfirm()">
                    Delete
                </button>
            </div>
            <div class="flex gap-3">
                <button
                    class="px-4 py-2 border border-gray-300 bg-white text-gray-700 rounded-md shadow-sm text-sm font-bold hover:bg-gray-50 transition"
                    (click)="closeForm()">Cancel</button>
                <button *ngIf="isCreateGroup"
                    class="px-4 py-2 bg-brandAccent hover:bg-brandPurple text-white rounded-md shadow-sm text-sm font-bold transition disabled:opacity-50 disabled:cursor-not-allowed"
                    [ngClass]="{'bg-red-500 hover:bg-red-600': saveBtnError}"
                    [disabled]="isGroupFormInvalid() || !isProcessed" (click)="saveGroup(group)">{{ saveBtnText
                    }}</button>
                <button *ngIf="!isCreateGroup"
                    class="px-4 py-2 bg-brandAccent hover:bg-brandPurple text-white rounded-md shadow-sm text-sm font-bold transition disabled:opacity-50 disabled:cursor-not-allowed"
                    [ngClass]="{'bg-red-500 hover:bg-red-600': updateBtnError}"
                    [disabled]="isGroupFormInvalid() || !isProcessed" (click)="updateGroup(group)">{{ updateBtnText
                    }}</button>
            </div>
        </div>
    </div>
</div>

<!-- ================================================================ -->
<!-- GROUP USERS PANEL -->
<!-- ================================================================ -->
<div *ngIf="isShowUserGroup"
    class="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
    <div class="bg-white w-full max-w-lg rounded-xl shadow-2xl flex flex-col overflow-hidden max-h-[90vh]">
        <!-- Header -->
        <div class="px-6 py-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center">
            <h2 class="text-xl font-bold text-gray-800">Group <strong>Users</strong></h2>
            <button class="text-gray-400 hover:text-gray-600 focus:outline-none" (click)="closeUserForm()">
                <span class="text-2xl font-light">&times;</span>
            </button>
        </div>

        <!-- Body -->
        <div class="p-6 overflow-y-auto flex flex-col gap-4">
            <!-- Search -->
            <input type="text" [(ngModel)]="searchUser"
                class="form-input text-sm p-2 border border-gray-300 rounded-md focus:ring-brandAccent focus:border-brandAccent"
                placeholder="Quick Search...">

            <!-- Users Table -->
            <div class="overflow-x-auto overflow-y-auto max-h-[400px] border border-gray-200 rounded-lg">
                <table class="min-w-full text-sm">
                    <thead class="bg-gray-50 text-left text-gray-600 border-b border-gray-200 sticky top-0">
                        <tr>
                            <th class="px-4 py-2 font-semibold text-center" style="width: 20%;">Assigned</th>
                            <th class="px-4 py-2 font-semibold cursor-pointer"
                                (click)="userSortType = 'name'; userSortReverse = !userSortReverse">
                                User Name
                                <span *ngIf="userSortType === 'name' && !userSortReverse" class="ml-1">▼</span>
                                <span *ngIf="userSortType === 'name' && userSortReverse" class="ml-1">▲</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-100">
                        <tr *ngIf="!isLoaded">
                            <td colspan="2" class="px-4 py-8 text-center text-gray-500 italic">Loading...</td>
                        </tr>
                        <tr *ngFor="let user of getFilteredLinkUsers()" class="hover:bg-pageBg transition-colors">
                            <td class="px-4 py-2 text-center">
                                <input type="checkbox"
                                    class="rounded border-gray-300 text-brandAccent focus:ring-brandAccent w-4 h-4 cursor-pointer"
                                    [checked]="isUserAssigned(user)"
                                    (change)="toggleAddAndDeleteUser(user, !isUserAssigned(user))">
                            </td>
                            <td class="px-4 py-2 font-medium">
                                {{ user.name }}
                                <span *ngIf="user.addMessage" class="text-green-600 text-xs ml-2 font-bold">
                                    ✓ {{ user.addMessage }}
                                </span>
                                <span *ngIf="user.deleteMessage" class="text-red-500 text-xs ml-2 font-bold">
                                    − {{ user.deleteMessage }}
                                </span>
                            </td>
                        </tr>
                        <tr *ngIf="isLoaded && getFilteredLinkUsers().length === 0">
                            <td colspan="2" class="px-4 py-8 text-center text-gray-500 italic">No users found.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="text-xs text-gray-400 text-right">
                {{ usersList.length }} user(s) assigned to this group
            </div>
        </div>

        <!-- Footer -->
        <div class="px-6 py-4 border-t border-gray-200 bg-gray-50 flex justify-end rounded-b-xl">
            <button
                class="px-4 py-2 border border-gray-300 bg-white text-gray-700 rounded-md shadow-sm text-sm font-bold hover:bg-gray-50 transition"
                (click)="closeUserForm()">Close</button>
        </div>
    </div>
</div>

<!-- ================================================================ -->
<!-- GROUP CHANNELS PANEL -->
<!-- ================================================================ -->
<div *ngIf="isShowUserChannel"
    class="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
    <div class="bg-white w-full max-w-lg rounded-xl shadow-2xl flex flex-col overflow-hidden max-h-[90vh]">
        <!-- Header -->
        <div class="px-6 py-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center">
            <h2 class="text-xl font-bold text-gray-800">Group <strong>Channels</strong></h2>
            <button class="text-gray-400 hover:text-gray-600 focus:outline-none" (click)="closeChannelForm()">
                <span class="text-2xl font-light">&times;</span>
            </button>
        </div>

        <!-- Body -->
        <div class="p-6 overflow-y-auto flex flex-col gap-4">
            <!-- Search -->
            <input type="text" [(ngModel)]="searchChannel" (input)="searchChannel = searchChannel"
                class="form-input text-sm p-2 border border-gray-300 rounded-md focus:ring-brandAccent focus:border-brandAccent"
                placeholder="Quick Search...">

            <!-- Channels Table -->
            <div class="overflow-x-auto overflow-y-auto max-h-[400px] border border-gray-200 rounded-lg">
                <table class="min-w-full text-sm">
                    <thead class="bg-gray-50 text-left text-gray-600 border-b border-gray-200 sticky top-0">
                        <tr>
                            <th class="px-4 py-2 font-semibold text-center" style="width: 20%;">Add</th>
                            <th class="px-4 py-2 font-semibold">Channel Name</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-100">
                        <tr *ngFor="let channel of getFilteredChannels()">
                            <td class="px-4 py-2 text-center">
                                <input type="checkbox" [(ngModel)]="channel.checked"
                                    class="rounded border-gray-300 text-brandAccent focus:ring-brandAccent w-4 h-4 cursor-pointer">
                            </td>
                            <td class="px-4 py-2 font-medium">{{ channel.name }}</td>
                        </tr>
                        <tr *ngIf="getFilteredChannels().length === 0">
                            <td colspan="2" class="px-4 py-8 text-center text-gray-500">
                                No channels found.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Footer -->
        <div class="px-6 py-4 border-t border-gray-200 bg-gray-50 flex justify-end rounded-b-xl">
            <button
                class="px-4 py-2 border border-gray-300 bg-white text-gray-700 rounded-md shadow-sm text-sm font-bold hover:bg-gray-50 transition"
                (click)="closeChannelForm()">Close</button>
        </div>
    </div>
</div>

<!-- ================================================================ -->
<!-- COLUMN SETTINGS SLIDE-OVER -->
<!-- ================================================================ -->
<div *ngIf="isColumnSettingsVisible" class="fixed inset-0 z-[90] flex justify-end">
    <div class="absolute inset-0 bg-black/30" (click)="isColumnSettingsVisible = false"></div>
    <div class="relative w-80 bg-white h-full shadow-2xl flex flex-col overflow-y-auto">
        <div class="px-6 py-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center">
            <h2 class="text-lg font-bold text-gray-800">Hide/Show <strong>Columns</strong></h2>
            <button class="text-gray-400 hover:text-gray-600 focus:outline-none"
                (click)="isColumnSettingsVisible = false">
                <span class="text-2xl font-light">&times;</span>
            </button>
        </div>
        <div class="p-6 flex flex-col gap-4">
            <label class="flex items-center gap-3 text-sm text-gray-700 cursor-pointer">
                <input type="checkbox" [(ngModel)]="columnVisibility['name']" [ngModelOptions]="{standalone: true}"
                    class="rounded border-gray-300 text-brandAccent focus:ring-brandAccent w-5 h-5">
                <span class="font-medium">Name</span>
            </label>
            <label class="flex items-center gap-3 text-sm text-gray-700 cursor-pointer">
                <input type="checkbox" [(ngModel)]="columnVisibility['addChannel']"
                    [ngModelOptions]="{standalone: true}"
                    class="rounded border-gray-300 text-brandAccent focus:ring-brandAccent w-5 h-5">
                <span class="font-medium">Channels</span>
            </label>
            <label class="flex items-center gap-3 text-sm text-gray-700 cursor-pointer">
                <input type="checkbox" [(ngModel)]="columnVisibility['addUsers']" [ngModelOptions]="{standalone: true}"
                    class="rounded border-gray-300 text-brandAccent focus:ring-brandAccent w-5 h-5">
                <span class="font-medium">Users</span>
            </label>
        </div>
    </div>
</div>